var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00004 4.76817L7.07274 7.84091C7.28485 8.05303 7.6288 8.05303 7.84091 7.84091C8.05303 7.62875 8.05303 7.28486 7.84091 7.07269L4.76821 4L7.84091 0.927282C8.05303 0.715157 8.05303 0.371229 7.84091 0.159104C7.6288 -0.0530257 7.28485 -0.0530257 7.07274 0.159104L4.00004 3.23183L0.927275 0.159093C0.715149 -0.0530312 0.37122 -0.0530312 0.159094 0.159093C-0.0530314 0.371224 -0.0530314 0.715146 0.159094 0.927277L3.23181 4L0.159094 7.07274C-0.0530314 7.28486 -0.0530314 7.62875 0.159094 7.84091C0.37122 8.05303 0.715149 8.05303 0.927275 7.84091L4.00004 4.76817Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close_red.c8c33bbc16fdd2d818efae37b7ff0398.svg";
export { ForwardRef as ReactComponent };